export default __webpack_public_path__ + "static/media/mona.71ed28ed.png";